<template>
  <v-autocomplete
    :model-value="modelValue"
    :items="items"
    :item-title="itemTitle"
    :item-value="itemValue"
    return-object
    :loading="loading"
    chips
    multiple
    clearable
    class="w-full my-autocomplete"
    :class="{
      'custom-border-primary': borderPrimary || (modelValue && modelValue.length > 0)
    }"
    color="primary20"
    variant="outlined"
    density="comfortable"
    :error="error"
    :error-messages="errorMessage"
    hide-details="auto"
    @update:model-value="onUpdateModelValue"
    @update:search="(val) => emit('update:search', val)"
  >
    <template #prepend-item>
      <v-list-item title="Selecionar Todos" @click="toggleSelectAll">
        <template #prepend>
          <v-checkbox-btn
            :model-value="allItemsSelected"
            :indeterminate="someItemsSelected"
            hide-details
          ></v-checkbox-btn>
        </template>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template #chip="{ item, index, props }">
      <v-chip
        v-if="allItemsSelected && index === 0"
        v-bind="props"
        class="bg-[#E2E2E9] text-black text-sm rounded-md px-1 py-1 border border-gray-500"
      >
        Todos
      </v-chip>

      <v-tooltip v-else-if="!allItemsSelected" :text="item.raw[itemTitle]" location="top">
        <template #activator="{ props: tooltipProps }">
          <v-chip
            v-bind="{ ...props, ...tooltipProps }"
            class="bg-[#E2E2E9] text-black text-sm rounded-md px-1 py-1 border border-gray-500"
          >
            {{ item.raw[itemTitle] }}
          </v-chip>
        </template>
      </v-tooltip>
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Item {
  title: string
  value: number | string
}

const props = defineProps<{
  modelValue: Item[]
  items: Item[]
  itemTitle?: string
  itemValue?: string
  loading?: boolean
  borderPrimary?: boolean
  error?: boolean
  errorMessage?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: Item[]): void
  (e: 'update:search', value: string): void
}>()

const onUpdateModelValue = (value: Item[]): void => {
  emit('update:modelValue', value)
}

const itemTitle = props.itemTitle || 'title'
const itemValue = props.itemValue || 'value'
const borderPrimary = props.borderPrimary ?? true

const allItemsSelected = computed(() => {
  if (!props.modelValue || props.items.length === 0) return false
  return props.modelValue.length === props.items.length
})

const someItemsSelected = computed(() => {
  if (!props.modelValue) return false
  return props.modelValue.length > 0 && !allItemsSelected.value
})

const toggleSelectAll = () => {
  if (allItemsSelected.value) {
    emit('update:modelValue', [])
  } else {
    emit('update:modelValue', [...props.items])
  }
}
</script>

<style scoped>
.my-autocomplete :deep(.v-input),
.my-autocomplete :deep(.v-input__control),
.my-autocomplete :deep(.v-field) {
  height: 100%;
}

.my-autocomplete.v-input {
  display: block;
}

.custom-border-primary .v-field {
  border: 1px solid #2f7f91 !important;
}
</style>
